// import React from "react";
// import { InputGroup } from "react-bootstrap";
// import Form from 'react-bootstrap/Form';

// type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

// export const InputField = (props: Props) => (
//   <div className="container" style={{padding:props.padding}}>
//     {props.label && (
//       <Form.Label htmlFor={props.label} style={{width:props.width,height:props.height}}>
//         {props.label}
      
//         {/* {props.type} */}
//         {props.required && <span style={{color:"red"}}>*</span>}
//       </Form.Label>
//     )}
//     <InputGroup style={{width:props.width,height:props.height}}>
//     <Form.Control {...props} />
//     {props.icon && (
//             <InputGroup.Text id="basic-addon1">{props.icon}</InputGroup.Text>
//   )}
//   </InputGroup>
//   </div>
// );

// export default InputField;

import React from "react";
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import  "../../css/InputField.Module.css";

export const InputField = (props) => (
  <div
    className="custom-input-container"
    style={{ padding: props.padding || "6px 12px" }}
  >
    {props.label && (
      <Form.Label htmlFor={props.id || props.label} className="custom-label">
        {props.label} {props.required && <span className="required">*</span>}
      </Form.Label>
    )}

    <InputGroup className="custom-input-group" style={{ width: props.width }}>
      <Form.Control {...props} className="custom-input" />
      {props.icon && <InputGroup.Text className="custom-icon">{props.icon}</InputGroup.Text>}
    </InputGroup>
  </div>
);

export default InputField;
